module.exports = "<p>\r\n  newcustomer works!\r\n</p>\r\n"